import { useMemo } from 'react'
import { useAuthStore } from '@/stores/auth'
import {
  SearchableLink,
  filterNavigationTabs,
  flattenSearchableLinks,
  navigationTabs,
} from '@/components/Navigation.shared'

/**
 * Permission-filtered, flattened navigation links for the command palette and
 * visit tracker. Mirrors exactly what the sidebar shows for the current user.
 */
export const useSearchableLinks = (): SearchableLink[] => {
  const userPermissions = useAuthStore(state => state.userPermissions)
  return useMemo(() => flattenSearchableLinks(filterNavigationTabs(navigationTabs, userPermissions)), [userPermissions])
}
